import { ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '@env/environment';

export const provideSentry = (): Provider[] => {
  if (!environment.production || !environment.sentry.dsn) {
    return [];
  }

  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    { provide: Sentry.TraceService, deps: [Router] },
  ];
};
